"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var whyData = [{
  avatar: /*#__PURE__*/_react.default.createElement("svg", {
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 174.3 174.3",
    xmlSpace: "preserve"
  }, /*#__PURE__*/_react.default.createElement("switch", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    style: {
      fill: '#FDBC36'
    },
    d: "M154.7,81.4c-3.2-0.4-5.9,0.3-8.3,2.7c-7.3,7.5-14.8,14.7-22.3,22c-1.1,1.1-2.9,2-4.4,2 c-6.5,0.2-13,0.1-19.5,0c-4-0.1-5.8-1.6-5.7-4.6c0-2.9,1.7-4.3,5.5-4.4c7.1-0.2,14.2-0.2,21.4-0.4c3.8-0.1,5.1-1.6,5.2-5.2 c0.1-3.9-1-5.6-4.9-5.7c-8.1-0.2-38-0.3-44.9-0.4c-5-0.1-9.2,1.6-12.7,4.9c-6.2,5.9-12.3,12.1-18.4,18c-1.4,1.3-1.4,2.2,0,3.5 c7.8,7.5,15.6,15,23.3,22.6c1.6,1.6,2.5,1.2,3.9-0.2c2.9-3,6-5.8,8.8-8.9c2.1-2.4,4.6-3.2,7.7-3.2c12.2,0.1,24.3,0,36.5-0.3 c1.8,0,4.1-0.8,5.1-2.1c9.1-11.2,18.1-22.6,26.9-34.1C159.8,85,158.2,81.8,154.7,81.4z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: "st0",
    d: "M38.6,112.3c-0.7-0.7-1.7-1.6-2.4-1.6c-0.8,0-1.6,0.6-2,1.1c-4.4,4.3-8.7,8.6-13,13 c-1.6,1.7-0.8,3,0.6,4.4c10.5,10.5,21,21,31.5,31.5c1.9,1.9,3.5,2,5.3,0.1c3.8-3.8,7.6-7.6,11.5-11.4c1.9-1.9,2.1-3.6,0.1-5.6 C59.6,133.2,49.2,122.7,38.6,112.3z"
  }))), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    style: {
      fill: '#939598'
    },
    d: "M91.2,21.8c-16.8,0.1-29.5,14.8-28.8,29.1c-0.7,14.6,11.4,29.5,29.4,29.7c15.9,0.1,29.2-13.2,29.3-29.2 C121.2,34.9,108,21.7,91.2,21.8z M91.6,72.2c-11.8,0-21.1-9.5-21-21.3c0.1-11.5,9.7-20.9,21.2-20.9c11.8,0,21.1,9.4,21,21.3 C112.6,63,103.2,72.3,91.6,72.2z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: "st1",
    d: "M95.3,49.8c-2-0.9-4-1.8-5.8-3c-0.7-0.5-1.4-1.8-1.2-2.5c0.3-0.9,1.4-2.2,2.2-2.3c2,0,4.2,0.1,6,1 c1.7,0.8,2.3,0.6,3.3-0.8c1.6-2.3,0.3-3.2-1.5-4.2c-1.9-1-4.7-1.1-4.3-4.4c0-0.4-1-0.9-1-0.9c-2.4-0.5-3,0.1-3.1,1.8 c-0.1,0.9-0.8,2.2-1.5,2.5c-3.3,1.5-5.6,3.8-5.6,7.6c-0.1,4.1,2.7,6.2,5.9,7.7c2,0.9,4,1.8,5.8,3c0.8,0.5,1.5,2.1,1.3,2.8 c-0.3,1-1.7,2.3-2.6,2.2c-2.1-0.1-4.4-0.5-6.2-1.5c-1.9-1-2.8-0.6-4,0.9c-1.4,1.9-0.1,2.7,1.2,3.5c1.1,0.8,2.5,1.1,3.7,1.9 c0.8,0.6,1.8,1.4,2,2.3c0.3,1.3,0.1,2.5,2.1,2.4c1.5-0.1,2.2-0.6,2.4-2.2c0.1-0.9,0.9-2.1,1.7-2.5c3.4-1.7,5.6-4.3,5.5-8.1 C101.3,53.2,98.5,51.3,95.3,49.8z"
  }))), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    style: {
      fill: '#E08F2C'
    },
    d: "M124.9,54.6c-4.3,0-8.6,0-12.8,0c-1.5,0-2.7-0.7-3.4-2c-0.3-0.6-0.4-1.3-0.4-1.9c0-6.7,0-13.4,0-20.1 c0-0.9,0-1.8,0-2.7c0-0.8,0.4-1.2,1.2-1.2c0.6,0,1.3,0,1.9,0c0.6,0,0.6,0,0.6-0.6c0-1,0-2,0-3c0-6.2,4.2-11.4,10.3-12.8 c5.9-1.3,11.9,1.7,14.5,7.1c0.9,1.9,1.3,3.9,1.3,6c0,0.9,0,1.9,0,2.8c0,0.4,0.1,0.5,0.5,0.5c0.6,0,1.2,0,1.9,0 c1,0,1.3,0.3,1.3,1.3c0,6.7,0,13.3,0,20c0,0.9,0,1.9,0,2.8c0,2.2-1.6,3.8-3.8,3.8C133.6,54.6,129.2,54.6,124.9,54.6 C124.9,54.6,124.9,54.6,124.9,54.6z M124.9,26.7C124.9,26.7,124.9,26.7,124.9,26.7c2.3,0,4.5,0,6.8,0c0.7,0,0.7,0,0.7-0.6 c0-1.1,0-2.1,0-3.2c0-3.9-3-7.1-7-7.3c-4.1-0.3-7.3,2.7-7.8,6.2c-0.2,1.4-0.1,2.9-0.1,4.4c0,0.6,0,0.6,0.6,0.6 C120.4,26.7,122.7,26.7,124.9,26.7z M125,47.2c0.5,0,1.1,0,1.6,0c0.9,0,1.2-0.4,1.1-1.3c-0.2-1.5-0.3-3-0.5-4.4 c0-0.4,0-0.7,0.3-0.9c0.7-0.6,1.1-1.5,1.1-2.5c0.1-1.7-1-3.2-2.6-3.7c-1.7-0.5-3.4,0.1-4.3,1.6c-0.9,1.4-0.7,3.3,0.5,4.5 c0.4,0.4,0.4,0.7,0.4,1.1c-0.2,1.5-0.3,2.9-0.5,4.4c-0.1,0.8,0.3,1.2,1.1,1.2C123.9,47.2,124.4,47.2,125,47.2z"
  }))))))),
  href: '/'
}, {
  avatar: /*#__PURE__*/_react.default.createElement("svg", {
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 174.3 174.3"
  }, /*#__PURE__*/_react.default.createElement("switch", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("rect", {
    x: "37.3",
    y: "30.8",
    style: {
      fill: '#FDBC36'
    },
    width: "97.1",
    height: "113.2"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "21.7",
    y: "30.8",
    style: {
      fill: '#E08F2C'
    },
    width: "15.6",
    height: "113.2"
  })), /*#__PURE__*/_react.default.createElement("rect", {
    x: "75.7",
    y: "30.7",
    style: {
      fill: '#E08F2C'
    },
    width: "14.2",
    height: "18.2"
  })), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    style: {
      fill: '#D39129'
    },
    d: "M118.8,84.2H86.8c-1.9,0-3.4-1.5-3.4-3.4V60.2c0-1.9,1.5-3.4,3.4-3.4h31.9c1.9,0,3.4,1.5,3.4,3.4v20.5 C122.2,82.7,120.7,84.2,118.8,84.2z"
  }), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    style: {
      fill: '#FFFFFF'
    },
    d: "M115.5,62.3H90.1c-0.4,0-0.8-0.4-0.8-0.8v-0.1c0-0.4,0.4-0.8,0.8-0.8h25.4c0.4,0,0.8,0.4,0.8,0.8v0.1 C116.3,62,115.9,62.3,115.5,62.3z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    style: {
      fill: '#FFFFFF'
    },
    d: "M115.5,65.9H90.1c-0.4,0-0.8-0.4-0.8-0.8V65c0-0.4,0.4-0.8,0.8-0.8h25.4c0.4,0,0.8,0.4,0.8,0.8v0.1 C116.3,65.6,115.9,65.9,115.5,65.9z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    style: {
      fill: '#FFFFFF'
    },
    d: "M115.5,69.5H90.1c-0.4,0-0.8-0.4-0.8-0.8v-0.1c0-0.4,0.4-0.8,0.8-0.8h25.4c0.4,0,0.8,0.4,0.8,0.8v0.1 C116.3,69.2,115.9,69.5,115.5,69.5z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    style: {
      fill: '#FFFFFF'
    },
    d: "M115.5,73.1H90.1c-0.4,0-0.8-0.4-0.8-0.8v-0.1c0-0.4,0.4-0.8,0.8-0.8h25.4c0.4,0,0.8,0.4,0.8,0.8v0.1 C116.3,72.8,115.9,73.1,115.5,73.1z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    style: {
      fill: '#FFFFFF'
    },
    d: "M115.5,76.7H90.1c-0.4,0-0.8-0.4-0.8-0.8v-0.1c0-0.4,0.4-0.8,0.8-0.8h25.4c0.4,0,0.8,0.4,0.8,0.8v0.1 C116.3,76.4,115.9,76.7,115.5,76.7z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    style: {
      fill: '#FFFFFF'
    },
    d: "M115.5,80.3H90.1c-0.4,0-0.8-0.4-0.8-0.8v-0.1c0-0.4,0.4-0.8,0.8-0.8h25.4c0.4,0,0.8,0.4,0.8,0.8v0.1 C116.3,80,115.9,80.3,115.5,80.3z"
  }))), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    style: {
      fill: '#625F64'
    },
    d: "M152.4,154.6h-50.8c-3.4,0-6.1-2.7-6.1-6.1V82.3c0-3.4,2.7-6.1,6.1-6.1h50.8c3.4,0,6.1,2.7,6.1,6.1v66.2 C158.5,151.8,155.8,154.6,152.4,154.6z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    style: {
      fill: '#FDBC36'
    },
    d: "M147.1,148.9H107c-2.2,0-4.1-1.8-4.1-4.1V94.3c0-2.2,1.8-4.1,4.1-4.1h40.1c2.2,0,4.1,1.8,4.1,4.1v50.5 C151.2,147,149.3,148.9,147.1,148.9z"
  }), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    style: {
      fill: '#FFFFFF'
    },
    d: "M117.1,109.7c-0.5-0.4-1.2-0.3-1.6,0.2l-3,3.8l-1.7-1.3c-0.4-0.3-1.1-0.2-1.4,0.2l-0.5,0.6 c-0.3,0.4-0.2,1.1,0.2,1.4l3.1,2.3c0.4,0.3,1.1,0.2,1.4-0.2l0.1-0.1c0,0,0,0,0,0l4-5c0.4-0.5,0.3-1.2-0.2-1.6L117.1,109.7z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    style: {
      fill: '#FFFFFF'
    },
    d: "M112.2,104.4c0.4,0.3,1.1,0.2,1.4-0.2l0.1-0.1c0,0,0,0,0,0l4-5c0.4-0.5,0.3-1.2-0.2-1.6l-0.4-0.3 c-0.5-0.4-1.2-0.3-1.6,0.2l-3,3.8l-1.7-1.3c-0.4-0.3-1.1-0.2-1.4,0.2l-0.5,0.6c-0.3,0.4-0.2,1.1,0.2,1.4L112.2,104.4z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    style: {
      fill: '#FFFFFF'
    },
    d: "M117.1,134.8c-0.5-0.4-1.2-0.3-1.6,0.2l-3,3.8l-1.7-1.3c-0.4-0.3-1.1-0.2-1.4,0.2l-0.5,0.6 c-0.3,0.4-0.2,1.1,0.2,1.4l3.1,2.3c0.4,0.3,1.1,0.2,1.4-0.2l0.1-0.1c0,0,0,0,0,0l4-5c0.4-0.5,0.3-1.2-0.2-1.6L117.1,134.8z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    style: {
      fill: '#FFFFFF'
    },
    d: "M117.1,122.2c-0.5-0.4-1.2-0.3-1.6,0.2l-3,3.8l-1.7-1.3c-0.4-0.3-1.1-0.2-1.4,0.2l-0.5,0.6 c-0.3,0.4-0.2,1.1,0.2,1.4l3.1,2.3c0.4,0.3,1.1,0.2,1.4-0.2l0.1-0.1c0,0,0,0,0,0l4-5c0.4-0.5,0.3-1.2-0.2-1.6L117.1,122.2z"
  })), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    style: {
      fill: '#FFFFFF'
    },
    d: "M144,101.4h-21.6c-0.8,0-1.4-0.6-1.4-1.4v-0.2c0-0.8,0.6-1.4,1.4-1.4H144c0.8,0,1.4,0.6,1.4,1.4v0.2 C145.4,100.7,144.7,101.4,144,101.4z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    style: {
      fill: '#FFFFFF'
    },
    d: "M144,114.8h-21.6c-0.8,0-1.4-0.6-1.4-1.4v-0.2c0-0.8,0.6-1.4,1.4-1.4H144c0.8,0,1.4,0.6,1.4,1.4v0.2 C145.4,114.1,144.7,114.8,144,114.8z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    style: {
      fill: '#FFFFFF'
    },
    d: "M144,127.8h-21.6c-0.8,0-1.4-0.6-1.4-1.4v-0.2c0-0.8,0.6-1.4,1.4-1.4H144c0.8,0,1.4,0.6,1.4,1.4v0.2 C145.4,127.2,144.7,127.8,144,127.8z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    style: {
      fill: '#FFFFFF'
    },
    d: "M144,141.2h-21.6c-0.8,0-1.4-0.6-1.4-1.4v-0.2c0-0.8,0.6-1.4,1.4-1.4H144c0.8,0,1.4,0.6,1.4,1.4v0.2 C145.4,140.6,144.7,141.2,144,141.2z"
  }))), /*#__PURE__*/_react.default.createElement("path", {
    style: {
      fill: '#FDBC36'
    },
    d: "M132.1,82.5h-3c0-0.1,0-0.2,0-0.3c0-1.2-1-2.2-2.2-2.2s-2.2,1-2.2,2.2c0,0.1,0,0.2,0,0.3h-3 c-1,0-1.8,0.8-1.8,1.8c0,1,0.8,1.8,1.8,1.8h10.2c1,0,1.8-0.8,1.8-1.8C133.9,83.3,133.1,82.5,132.1,82.5z"
  })))))),
  href: '/'
}, {
  avatar: /*#__PURE__*/_react.default.createElement("svg", {
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 174.3 174.3"
  }, /*#__PURE__*/_react.default.createElement("switch", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("rect", {
    x: "109.2",
    y: "88.6",
    style: {
      fill: '#FDBC36'
    },
    width: "28.9",
    height: "35"
  }), /*#__PURE__*/_react.default.createElement("polygon", {
    style: {
      fill: '#DF8D2E'
    },
    points: "109.2,123.6 104,123.6 104,89.5 109.2,88.6 \t\t\t\t\t"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "121.1",
    y: "88.6",
    style: {
      fill: '#DF8D2E'
    },
    width: "5.2",
    height: "8.7"
  })), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("rect", {
    x: "107.9",
    y: "46.1",
    transform: "matrix(0.8658 -0.5004 0.5004 0.8658 -15.41 69.7725)",
    style: {
      fill: '#FDBC36'
    },
    width: "28.9",
    height: "35"
  }), /*#__PURE__*/_react.default.createElement("polygon", {
    style: {
      fill: '#DF8D2E'
    },
    points: "118.6,86 114.1,88.6 97.2,59.3 101.1,55.7 \t\t\t\t\t"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "113.2",
    y: "47.9",
    transform: "matrix(0.8658 -0.5004 0.5004 0.8658 -10.6021 64.9585)",
    style: {
      fill: '#DF8D2E'
    },
    width: "5.2",
    height: "8.7"
  })), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("rect", {
    x: "50.1",
    y: "62.8",
    style: {
      fill: '#FDBC36'
    },
    width: "51.8",
    height: "60.7"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "40.9",
    y: "62.8",
    style: {
      fill: '#DF8D2E'
    },
    width: "9.3",
    height: "60.7"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "71.4",
    y: "62.8",
    style: {
      fill: '#DF8D2E'
    },
    width: "9.3",
    height: "15.1"
  }))), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    style: {
      fill: '#B3B0B5'
    },
    d: "M156,143.3H34.1c-5.4,0-9.9-4.4-9.9-9.9v0c0-5.4,4.4-9.9,9.9-9.9H156c5.4,0,9.9,4.4,9.9,9.9v0 C165.8,138.8,161.4,143.3,156,143.3z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    style: {
      fill: '#B3B0B5'
    },
    d: "M28.5,133.4L28.5,133.4c-2.3,0-4.2-1.9-4.2-4.2V27.9c0-2.3,1.9-4.2,4.2-4.2h0c2.3,0,4.2,1.9,4.2,4.2v101.4 C32.7,131.5,30.8,133.4,28.5,133.4z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    style: {
      fill: '#D39429'
    },
    d: "M27.4,31.2l-16.6-7.1c-2-0.8-2.9-3.2-2.1-5.1l0,0c0.8-2,3.2-2.9,5.1-2.1L30.5,24c2,0.8,2.9,3.2,2.1,5.1 l0,0C31.7,31.2,29.4,32.1,27.4,31.2z"
  })), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("circle", {
    style: {
      fill: '#29262E'
    },
    cx: "44.6",
    cy: "143.9",
    r: "13.5"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    style: {
      fill: '#CF9030'
    },
    cx: "44.6",
    cy: "143.9",
    r: "6.9"
  })), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("circle", {
    style: {
      fill: '#29262E'
    },
    cx: "146.2",
    cy: "143.9",
    r: "13.5"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    style: {
      fill: '#CF9030'
    },
    cx: "146.2",
    cy: "143.9",
    r: "6.9"
  })))))))),
  href: '/'
}, {
  avatar: /*#__PURE__*/_react.default.createElement("svg", {
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 174.3 174.3"
  }, /*#__PURE__*/_react.default.createElement("switch", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    style: {
      fill: '#B3B0B5'
    },
    d: "M160.9,128.9h-56.2c-0.6,0-1.1-0.4-1.1-1v-25.4c0-0.5,0.5-1,1.1-1h53.4c0.6,0,1.1,0.4,1.1,1l2.8,25.4 C162,128.5,161.5,128.9,160.9,128.9z"
  }), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("rect", {
    x: "96.1",
    y: "59.3",
    style: {
      fill: '#DF8D2E'
    },
    width: "7.5",
    height: "75"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "12",
    y: "129",
    style: {
      fill: '#DF8D2E'
    },
    width: "91.6",
    height: "5.4"
  })), /*#__PURE__*/_react.default.createElement("rect", {
    x: "103.6",
    y: "129",
    style: {
      fill: '#4A4A4A'
    },
    width: "60.7",
    height: "5.4"
  })), /*#__PURE__*/_react.default.createElement("path", {
    style: {
      fill: '#FDBC36'
    },
    d: "M96.1,59.3H13.6c-0.9,0-1.6,0.7-1.6,1.6v15.8v7.5v43.2c0,0.9,0.7,1.6,1.6,1.6h82.4c0.9,0,1.6-0.7,1.6-1.6 V60.9C97.7,60,97,59.3,96.1,59.3z"
  }), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("ellipse", {
    style: {
      fill: '#29262E'
    },
    cx: "42.9",
    cy: "134.4",
    rx: "15.7",
    ry: "15.3"
  }), /*#__PURE__*/_react.default.createElement("ellipse", {
    style: {
      fill: '#CF9030'
    },
    cx: "42.9",
    cy: "134.4",
    rx: "8.1",
    ry: "7.9"
  })), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("ellipse", {
    style: {
      fill: '#29262E'
    },
    cx: "138.8",
    cy: "134.4",
    rx: "15.7",
    ry: "15.3"
  }), /*#__PURE__*/_react.default.createElement("ellipse", {
    style: {
      fill: '#CF9030'
    },
    cx: "138.8",
    cy: "134.4",
    rx: "8.1",
    ry: "7.9"
  }))), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    style: {
      fill: '#FFFFFF'
    },
    d: "M40.3,93.3h-6.9v7.1h-3V83.7h10.9V86h-7.9v5h6.9V93.3z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    style: {
      fill: '#FFFFFF'
    },
    d: "M49.9,94h-3.3v6.4h-3V83.7h6c2,0,3.5,0.4,4.6,1.3c1.1,0.9,1.6,2.1,1.6,3.7c0,1.1-0.3,2.1-0.8,2.8 c-0.6,0.8-1.3,1.3-2.3,1.7l3.8,6.9v0.1h-3.2L49.9,94z M46.6,91.6h3.1c1,0,1.8-0.2,2.4-0.7c0.6-0.5,0.8-1.2,0.8-2 c0-0.9-0.3-1.6-0.8-2.1c-0.5-0.5-1.3-0.7-2.3-0.8h-3.1V91.6z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    style: {
      fill: '#FFFFFF'
    },
    d: "M68.7,92.9h-7v5.1h8.2v2.3H58.7V83.7h11.1V86h-8.1v4.6h7V92.9z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    style: {
      fill: '#FFFFFF'
    },
    d: "M82.3,92.9h-7v5.1h8.2v2.3H72.3V83.7h11.1V86h-8.1v4.6h7V92.9z"
  }))), /*#__PURE__*/_react.default.createElement("path", {
    style: {
      fill: '#B3B0B5'
    },
    d: "M158.8,101.8c-0.4-1.7-20.3-4.1-20.3-4.8l-9.2-15.4c0-2.7-4.1-4.9-7.2-4.9h-13c-3.1,0-5.6,2.2-5.6,5v21 c0,0.7,0.7,1.3,1.5,1.3h49.7C157.1,104,160.5,109.8,158.8,101.8z M131.5,97.5h-24.2c-0.3,0-0.6-0.2-0.6-0.6V83.1 c0-0.3,0.2-0.6,0.6-0.6h18.3c0.2,0,0.5,0.2,0.5,0.4l6,13.9C132.2,97.1,131.9,97.5,131.5,97.5z"
  }))))),
  href: '/'
}];
var _default = whyData;
exports.default = _default;